import { render, staticRenderFns } from "./UsersPassed.vue?vue&type=template&id=5c36700b&"
import script from "./UsersPassed.vue?vue&type=script&lang=js&"
export * from "./UsersPassed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports